import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';
import {Router} from '@angular/router';
import {PermissionService} from '@shared/service/permission.service';
import {LoaderService} from '@shared/service/loader.service';
import {QuotationService, QuotationServiceActionType} from '../../../services/quotation.service';
import {QuotationModel} from 'app/authority/authority-op/models/quotation.model';
import {CommoditiesService} from '@shared/service/commodities.service';
import {MessageManagerService} from '@shared/service/message-manager/message-manager.service';
import {DossierAndWorkingStates, DossierWorkingWoe, WorkingTypes} from '../../../models/enums.model';
import {Subscription} from 'rxjs';
import {ConsipFlowService} from '../../../services/consip-flow.service';
import {WorkingsService} from 'app/authority/authority-shared/services/workings.service';
import {FormItemsModel} from 'app/authority/authority-shared/models/form-items.model';
import {Utilities} from '@shared/utilities/utilities.model';
import { TranslateContext, TranslatePipe } from '@shared/pipes/translate.pipe';
import { NemoModuleKeys } from '@shared/models/user-permission.model';
import { ERejectionType, RespWorkingDissociable, WorkingModel } from 'app/authority/authority-shared/models/working.model';
import { MessageManagerUtilities } from '@shared/service/message-manager/message-manager-utilities';
import { ErrorResponse } from '@shared/models/error-response.model';
import { InnerMessageAuthorityMessageCode } from 'app/authority/authority-shared/services/inner-message-authority-utilities';
import { CommonMessageCode, MessageComponentType, MessageDetail, MessageType } from '@shared/service/message-manager/message.model';
import { WarningDialogComponent } from '@shared/components/warning-dialog/warning-dialog.component';
import { GeneralMessageDialogComponent, GeneralMessageModel } from '@shared/components/general-message-dialog/general-message-dialog.component';
import { DossierModel } from '@authority/authority-shared/models/dossier.model';
import { AUTHORITY_OPERATOR_USER, AUTHORITY_SUPERVISOR_USER } from 'app/permissions-variables';
import { logger } from '@app/shared/utilities/logger.model';

export interface QuotationDeclineDialogData {
	workingNumber: string;
	context: QuotationDeclineDialogContext;
	dossierId?: string;
	category?: WorkingTypes;
	workingId?: string;
	quotationId?: string;
	quotation?: QuotationModel;
	commodity?: string;
	item?: FormItemsModel;
	dossierWorkingQualification?: DossierWorkingWoe;
	declined_note_required?: boolean;
	dossier?: DossierModel;
	working?: WorkingModel;
}

export enum QuotationDeclineDialogContext {
	DECLINE = 'DECLINE',
	RE_DECLINE = 'RE_DECLINE',
	SUPER_REJECT = 'SUPER_REJECT',
	GLASS_REJECT = 'GLASS_REJECT',
	CONSIP_REJECT = 'CONSIP_REJECT',
	SUPER_DECLINE = 'SUPER_DECLINE',
	ADMINISTRATION_REJECT = 'ADMINISTRATION_REJECT',
	REJECT = 'REJECT'
}

@Component({
	selector: 'amd-authority-quotation-decline-dialog',
	templateUrl: './authority-quotation-decline-dialog.component.html',
	styleUrls: ['./authority-quotation-decline-dialog.component.scss']
})
export class AuthorityQuotationDeclineDialogComponent implements OnInit, OnDestroy {

	workingTypes: typeof WorkingTypes = WorkingTypes;
	contextEnum: typeof QuotationDeclineDialogContext = QuotationDeclineDialogContext;
	form: FormGroup;
	formRejectionType: FormGroup;
	formCluster: FormGroup;
	category: WorkingTypes;
	workingId: string;
	workingNumber: string;
	context: QuotationDeclineDialogContext;
	dossierID: string;
	quotationId: string;
	dossierWorkingQualification: DossierWorkingWoe;
	quotation: QuotationModel;
	dossier: DossierModel;
	working: WorkingModel;
	commodity: string;
	formSubscription: Subscription;
	title: string;
	item: FormItemsModel;
	declined_note_required: boolean = true;
	dossierWorkingWoe: typeof DossierWorkingWoe = DossierWorkingWoe;
	isLoading: boolean;
	t: TranslateContext = TranslateContext.AUTHORITY;
	maxChars: number;
	rejectionTypeList: ERejectionType[] = [ ERejectionType.WRECK, ERejectionType.SUSPENSION, ERejectionType.OTHER ];
	isALD: boolean = false;
	isCluster: boolean = false;
  	CONFIRM_DIALOG_MSG: string[] = [
		'NON_SI_PROCEDERA_ALLO_SGANCIO_DELLA_RIPARAZIONE',
		'SI_PROCEDERA_ALLO_SGANCIO',
		'LA_PRATICA_NON_PUO_ESSERE_RIFIUTATA',
	];
	clusterSelect: {key: string, value: string}[] =[];

	get isFormClusterValid():boolean{
		return ( (this.formCluster && this.formCluster.enabled) ? this.formCluster.valid : true);
	}

	isFormRejectionTypeVisible: boolean

	constructor(
		public fb: FormBuilder, private commService: CommoditiesService,
		public dialogRef: MatDialogRef<AuthorityQuotationDeclineDialogComponent>,
		public router: Router,
		public permissionService: PermissionService,
		public loaderService: LoaderService,
		private messageManagerService: MessageManagerService,
		private quotationService: QuotationService,
		private consipFlowService: ConsipFlowService,
		private workingService: WorkingsService,
		private translatePipe: TranslatePipe,
		private _dialog: MatDialog,
		@Inject(MAT_DIALOG_DATA) private data: QuotationDeclineDialogData
	) {
	}

	ngOnInit(): void {
	
		// this.isALD = this.permissionService.getCurrentUserPermissions().isAldOperator(NemoModuleKeys.AUTHORITY);
		this.isALD = this.permissionService.getCurrentUserPermissions().isAldOperator2();
		this.isCluster = this.permissionService.getCurrentUserPermissions().hasProfile([AUTHORITY_SUPERVISOR_USER, AUTHORITY_OPERATOR_USER])

		if (!Utilities.isVoid(this.data.declined_note_required)) {
			this.declined_note_required = this.data.declined_note_required;
		}
		this.setForm();
		this.category = this.data.category;
		// this.dossierID = this.data.dossierId;
		// this.workingId = this.data.workingId;
		this.quotationId = this.data.quotationId;
		this.context = this.data.context;
		this.workingNumber = this.data.workingNumber;
		this.item = this.data.item;
		this.dossierWorkingQualification = this.data.dossierWorkingQualification;
		this.quotation = this.data.quotation;
		
		this.dossier = this.data.dossier;
		this.working = this.data.working;
		this.dossierID = this.dossier ? this.data.dossier.id : this.data.dossierId;
		this.workingId = this.working ? this.data.working.id : this.data.workingId;
		
		this.setWorkingsCluster();
		this.formCluster.controls['cluster'].setValue(this.data.working.cluster);
		if(this.context == QuotationDeclineDialogContext.GLASS_REJECT){
			this.maxChars = 200;
		}
		if (this.dossierWorkingQualification === DossierWorkingWoe.CONTRACT_EXPIRED || this.dossierWorkingQualification === DossierWorkingWoe.WRECK) {
			switch (this.context) {
				case QuotationDeclineDialogContext.SUPER_REJECT:
					this.title = `Stai per confermare il blocco della pratica `;
					break;
				case QuotationDeclineDialogContext.SUPER_DECLINE:
					this.title = `Stai per rifiutare il blocco della pratica `;
					break;
				case QuotationDeclineDialogContext.ADMINISTRATION_REJECT:
					this.title = `Stai per rifiutare la pratica `;
					break;
				case QuotationDeclineDialogContext.REJECT:
					this.title = `Attenzione, si sta per effettuare il rifiuto definitivo della pratica. Se non si è in presenza di wreck o contratti scaduti, procedere a disassociare eventuali sinistri selezionati sulla pratica togliendo l'apposito flag.`;
					break;
			}
		} else {
			switch (this.context) {
				case QuotationDeclineDialogContext.REJECT:
					this.title = `Attenzione, si sta per effettuare il rifiuto definitivo della pratica. Se non si è in presenza di wreck o contratti scaduti, procedere a disassociare eventuali sinistri selezionati sulla pratica togliendo l'apposito flag.`;
					break;
			}
		}

		if (this.quotation) {
			this.getCommById();
		} else {
			this.commodity = this.data.commodity;
		}

		// condizione per nascondere il campo "tipo rifiuto"
		// viene usata anche per escludere la validazione sul campo
		// quando viene disabilitato il bottone
		this.isFormRejectionTypeVisible = this.isALD && this.context !== this.contextEnum.DECLINE;
	}

	ngOnDestroy(): void {
		if (this.formSubscription) {
			this.formSubscription.unsubscribe();
		}
	}

	confirmDialog(msg: string) {
		return this._dialog.open(WarningDialogComponent, {
			height: 'auto',
			width: '600px',
			data: {
				title: this.translatePipe.transform('ATTENZIONE', this.t),
				message:this.translatePipe.transform(msg, this.t),
			}
		});
	}

	generalMessageDialog(msg: string) {
		const msgModel: GeneralMessageModel = new GeneralMessageModel({
			title:   GeneralMessageModel.TITLE_WARNING,
			txts:    [msg],
			buttons: [{
								txt: GeneralMessageModel.TXT_BUTTON_CC_SPO_CONFIRM_TERMINATION_CONTRACT_CONFIRM,
								style: GeneralMessageModel.BUTTON_STYLE_RAISED,
								action: true
							}],
			showCloseButton: false,
			type: GeneralMessageModel.MESSAGE_TYPE_3,
		});
		const dialogRef: MatDialogRef<GeneralMessageDialogComponent> = this._dialog.open(GeneralMessageDialogComponent, {
			height: 'auto',
			width: '800px',
			disableClose: true
		}) as MatDialogRef<GeneralMessageDialogComponent>;
		dialogRef.componentInstance.generalMessageDialog = msgModel;
		return dialogRef;
	}
	
	/*
	 *  Gestisce lo sgancio del sinistro, e il rifiuto della pratica
	 *
	 */
	callbackDissociateDamage(rejectionType: ERejectionType, isDissociate: boolean, working: WorkingModel): void {

		try {
			
			const isTypeReject: boolean = working.status === DossierAndWorkingStates.REJECTED;
	
			// Il sinistro non si può sganciare 
			// 1) viene rifiutata ugualmente (solo con WRECK / SCADUTO)
			if (!isDissociate) {
	
				if ([ERejectionType.WRECK, ERejectionType.SUSPENSION].includes(rejectionType)) {
	
					// 2) se una pratica è stata già Rifiutata, non deve partire la PATCH a /reject
					if (!isTypeReject) {
					
						this.sendDeclineQuotation();
					}
				}
	
				this.dialogRef.close();
				return;
			}
	
			// Il sinistro si può sganciare
			this.loading(true);
			this.workingService.deleteWorkingDissasociable(this.workingId, rejectionType)
				.subscribe((res: any | ErrorResponse) => {
	
					// togliere il sinistro dal FE
					working.claimsList = [];
	
					if (!(res instanceof ErrorResponse)) {
	
						// INVIA RIFIUTO DEFINITIVO
						if (!isTypeReject) {
	
							this.loading(true);
							this.sendDeclineQuotation(); 
							return;
						}
					}
					
					this.loading(false);
					// this.messageManagerService.pushInnerMessage({...MessageManagerUtilities.getMessageDetailsFromResponse(res), ...{isTop: false}});
					return;
			});

		} catch (e) {
			logger.error('Error in callbackDissociateDamage> ', e);
		}

		return;
	};

	loading(x: boolean): void {
		this.isLoading = x;
		this.loaderService.display(x); 
	}

	onConfirmClick(): void {

		this.isLoading = true;
		this.loaderService.display(true); 

		// Se la pratica non ha nessun sinistro associato, fai direttamente la REJECT senza passare per claims

		// Commentare per simulare l'anomalia 
		// di rifiuto senza aver sganciato il sinistro
		if (this.isRejectTypeToHandle()) {
			this.sendDeclineQuotation();
			//this.isLoading = false;
			//this.loaderService.display(false);
			return; 
		} 

		const rejection_type: ERejectionType = this.formRejectionType.controls['rejection_type'].value;

		// RICHIESTA DI SGANCIO per wreck / scaduto
		// serve per capire se il sinistro si può dissociare dalla pratica
		this.workingService.getWorkingDissasociable(this.workingId, rejection_type)
			.subscribe((res: RespWorkingDissociable | ErrorResponse) => {

				// response null
				if (!res) {
					this.messageManagerService.pushInnerMessage({
						code: 			   InnerMessageAuthorityMessageCode.GENERIC_ERROR,
						componentType: MessageComponentType.FLASH_MESSAGE,
						type:   			 MessageType.TYPE_ERROR,
						...{isTop: false}
					});
					this.isLoading = false;
					this.loaderService.display(false);
					return;
				}

				// HTTP error
				if (res && res instanceof ErrorResponse && res.error && res.message) {
					this.messageManagerService.pushInnerMessage({...MessageManagerUtilities.getMessageDetailsFromResponse(res), ...{isTop: false}});
					this.isLoading = false;
					this.loaderService.display(false);
					return;
				}

				if (res && res instanceof RespWorkingDissociable) {

					// NB: per avere i dettagli sulla dissociabilità del sinistro
					// guardare il commento sopra la classe RespWorkingDissociable
					const isDissociable: boolean = res.is_dissociable;

					/*
					*  +++ DISCLAIMER +++
					*
					*  Lo sgancio si può fare solo se la pratica è dissociabile
					*
					*  WRECK / SCADUTO la pratica si può sempre rifiutare, anche se il sinistro non è dissociabile/sganciabile
					*  per ALTRO  		 la pratica si può rifiutare solo se è dissociabile/sganciabile
					* 
					*/ 

					// il sinistro non è sganciabile e rejection_type è ALTRO
					// la pratica non può essere rifiutata
					if (!isDissociable && rejection_type === ERejectionType.OTHER) {
							
						this.generalMessageDialog(this.translatePipe.transform(this.CONFIRM_DIALOG_MSG[2], this.t));
						this.isLoading = false;
						this.loaderService.display(false);
						return;
					}
					
					this.loading(false);
					this.confirmDialog(this.translatePipe.transform(this.CONFIRM_DIALOG_MSG[+(isDissociable)], this.t)).afterClosed().subscribe(res => {
						
						try {
							
							if (!res) {
								this.dialogRef.close(); 
								this.isLoading = false;
								this.loaderService.display(false);
								return;
							}
	
							// controlla se è dissociabile e rifiuta (se possibile)
							this.callbackDissociateDamage(rejection_type, isDissociable, this.working);
							// this.isLoading = false;
							// this.loaderService.display(false);
							
						} catch (error) {

							logger.error('Error after confirmDialog: ', error);
						}
					});
				}

			}, 
			(e) => console.error(e),
			() => {
				this.isLoading = false;
				this.loaderService.display(false);
			}
		);
	}

	private setForm(): void {

		// TODO
		// usare un solo FormGroup
		// e abilitare/disabilitare i campi a seconda del contesto

		if (this.dossierWorkingQualification !== this.dossierWorkingWoe.WRECK || this.context === QuotationDeclineDialogContext.DECLINE) {
			this.form = this.fb.group({
				declined_note: ['', this.declined_note_required ? Validators.required : null],
			});
		}
		this.formSubscription = this.form.controls['declined_note'].valueChanges.subscribe(value => {
			if (value && this.form.controls['declined_note'].value !== value.trimStart()) {
				this.form.controls['declined_note'].setValue(value.trimStart());
			}
		});

		this.formRejectionType = this.fb.group({
			rejection_type: [null, this.isFormRejectionTypeVisible ? Validators.required : null],
		})
		this.formCluster = this.fb.group({
			cluster: [null, Validators.required]
		});
		
		// if(this.isCluster && (this.data.context === this.contextEnum.SUPER_DECLINE || this.data.context === this.contextEnum.RE_DECLINE || this.data.context === this.contextEnum.DECLINE || this.data.context === this.contextEnum.REJECT || this.data.context === this.contextEnum.CONSIP_REJECT)){
		// 	this.formCluster.enable();
		// }
		// else{
		// 	this.formCluster.disable();
		// }

		const context4FormCluster = [
			this.contextEnum.SUPER_DECLINE,
			this.contextEnum.RE_DECLINE,
			this.contextEnum.DECLINE,
			this.contextEnum.REJECT,
			this.contextEnum.CONSIP_REJECT,
		]
		this.isCluster && context4FormCluster.includes(this.data.context) ? this.formCluster.enable() : this.formCluster.disable();
			
	}

	isFormValid(): boolean {
		return this.form.valid && this.formRejectionType.valid && this.isFormClusterValid;
	}

	private getCommById(): void {
		this.commService.getAllCenter(this.quotation.commodityId,
			response => {
				if (response) {
					this.commodity = response.name;
				}
			},
			message => {
				this.messageManagerService.pushInnerMessage({...message, ...{isTop: false}});
			});
	}

	private sendDeclineQuotation(): void {
		this.loading(true);
		// this.loaderService.display(true);
		switch (this.context) {
			case QuotationDeclineDialogContext.DECLINE:
				this.quotationDeclineOrRejectPatch(QuotationServiceActionType.DECLINE);
				break;
			case QuotationDeclineDialogContext.RE_DECLINE:
				this.quotationDeclineOrRejectPatch(QuotationServiceActionType.RE_DECLINE);
				break;
			case QuotationDeclineDialogContext.SUPER_REJECT:
				this.quotationDeclineOrRejectPatch(QuotationServiceActionType.SUPER_REJECT);
				break;
			case QuotationDeclineDialogContext.SUPER_DECLINE:
				this.quotationDeclineOrRejectPatch(QuotationServiceActionType.SUPER_DECLINE);
				break;
			case QuotationDeclineDialogContext.CONSIP_REJECT:
				this.consipReject();
				break;
			case QuotationDeclineDialogContext.GLASS_REJECT:
				this.dialogRef.close(this.form.controls['declined_note'].value);
				this.isLoading = false;
				this.loaderService.display(false);
				break;
			case QuotationDeclineDialogContext.ADMINISTRATION_REJECT:
				this.rejectAdministrationPractice();
				break;
			case QuotationDeclineDialogContext.REJECT:
				this.quotationDeclineOrRejectPatch(QuotationServiceActionType.REJECT);
				break;
		}
		this.loaderService.display(false);
	}

	private quotationDeclineOrRejectPatch(type: QuotationServiceActionType): void {
		this.loaderService.display(true);
		let index = this.clusterSelect.findIndex(elem => elem.key === this.formCluster.controls['cluster'].value);
		this.quotationService.quotationServiceDoPatch(
			this.dossierID, this.workingId, this.quotationId, type,
			// success
			message => {
				this.dialogRef.close(true);
				this.messageManagerService.pushInnerMessage(message);
				// cambiare stato aggiornato *REJECTED*
				this.working.status = DossierAndWorkingStates.REJECTED;
				this.isLoading = false;
				this.loaderService.display(false);
			// failure
			}, message => {
				this.messageManagerService.pushInnerMessage({...message, ...{isTop: false}});
				this.isLoading = false;
				this.loaderService.display(false);
			},
			{
				declined_note: this.form.controls['declined_note'].value,
				cluster: (index != -1) ? this.clusterSelect[index].key : null,
				cluster_description: (index != -1) ? this.clusterSelect[index].value : null,
				rejection_type: ((type: QuotationServiceActionType, val: ERejectionType): (ERejectionType | null) => { 
					return [QuotationServiceActionType.SUPER_REJECT, QuotationServiceActionType.REJECT].includes(type) ? val : null;
				})(type, this.formRejectionType.controls['rejection_type'].value),
			},
			!this.isRejectTypeToHandle() // deve dissociare il sinistro da authority?
			);
	}

	private consipReject(): void {
		this.loaderService.display(true);
		let index = this.clusterSelect.findIndex(elem => elem.key === this.formCluster.controls['cluster'].value);
		this.consipFlowService.consipReject(this.dossierID, this.workingId, this.quotationId, message => {
				this.messageManagerService.pushInnerMessage(message);
				this.isLoading = false;
				this.loaderService.display(false);
				this.dialogRef.close(true);
			}, message => {
				this.messageManagerService.pushInnerMessage({...message, ...{isTop: false}});
				this.isLoading = false;
				this.loaderService.display(false);
			},
			{
				declined_note: this.form.controls['declined_note'].value,
				rejection_type: this.formRejectionType.controls['rejection_type'].value,
				cluster: (index != -1) ? this.clusterSelect[index].key : null,
				cluster_description: (index != -1) ? this.clusterSelect[index].value : null,
			});
	}

	private rejectAdministrationPractice(): void {
		this.loaderService.display(true);
		this.workingService.rejectPractice(this.item, this.dossier, this.workingId, message => {
				this.messageManagerService.pushInnerMessage(message);
				this.isLoading = false;
				this.loaderService.display(false);
				this.dialogRef.close(true);
			}, message => {
				this.messageManagerService.pushInnerMessage({...message, ...{isTop: false}})
				this.isLoading = false;
				this.loaderService.display(false);
			},
			{declined_note: this.form.controls['declined_note'].value});
	}
	
	/**
	 * Il metodo dice se deve essere gestito
	 * il tipo di rifiuto e la dissociazione del sinistro
	 * 
	 * @returns {boolean}
	 */ 
	isRejectTypeToHandle(): boolean {

		// TODO
		// sistemare, vanno invertite le logiche

		// Non va gestito se:
		
		return (
			// Per CARGLASS
			[QuotationDeclineDialogContext.GLASS_REJECT, QuotationDeclineDialogContext.DECLINE].includes(this.context) || 
			
			// Se la pratica non ha il sinistro associato 
			!this.working || !this.working.claimsList || !this.working.claimsList.length
		);
	}

	private setWorkingsCluster(){

		if (Utilities.isEmpty(this.working)) {
			logger.error('Working is empty');
			return;
		}

		if (
			Utilities.isEmpty(this.workingService.workingClusterSelect) ||
			Utilities.isEmpty(this.workingService.workingClusterSelect.cluster_map)
		) {
			
			const msg: MessageDetail = {
				componentType: MessageComponentType.FLASH_MESSAGE,
				type: MessageType.TYPE_ERROR,
				code: CommonMessageCode.EMPTY_MESSAGE,
				message: this.translatePipe.transform('ERR__RICEZIONE_CLUSTER', TranslateContext.AUTHORITY)
			};
			this.messageManagerService.pushInnerMessage({...msg, ...{isTop: false}})
			logger.error('Error retrieving working cluster, missing workingClusterSelect or cluster_map');
			return;
		}

		// const fn = (type: string): void => {
		// 	const clusterMap = this.workingService.workingClusterSelect.cluster_map[type];
		// 	Object.keys(clusterMap).forEach(key => this.clusterSelect.push({key: key, value: clusterMap[key]}));
		// };
		// fn(this.working.type);

		try {
	
			if(this.working.type === this.workingTypes.CARBODY){
				Object.keys(this.workingService.workingClusterSelect.cluster_map.CARBODY).forEach(
					(key)=>{
						this.clusterSelect.push({key: key, value: this.workingService.workingClusterSelect.cluster_map.CARBODY[key]})
						}
				)
			}
			else if(this.working.type === this.workingTypes.MECHANIC){
				Object.keys(this.workingService.workingClusterSelect.cluster_map.MECHANIC).forEach(
					(key)=>{
						this.clusterSelect.push({key: key, value: this.workingService.workingClusterSelect.cluster_map.MECHANIC[key]})
						}
				)
			}

		} catch(e) {
			logger.error('Error retrieving working cluster> ', e);
			return;
		}
	}
}
